import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { useDefaultObservable } from "utils/libExtend/useDefaultObservable";

export const createUseDefaultObservable = <T>(): ((observable: BehaviorSubject<T>) => T) => {
  return (observable: BehaviorSubject<T>) => useDefaultObservable<T>(observable);
};
